import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../utils/api';
import moment from 'moment';
import './styles/TeacherProfilePage.css';
import { useNavigate } from 'react-router-dom';

const StockDetailPage = ({isSidebarCollapsed}) => {
    const { inventoryId } = useParams(); 
    const [inventory, setInventory] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchInventoryDetails = async () => {
            try {
                const response = await api.get(`/inventory/detail/${inventoryId}`);
                setInventory(response.data?.data[0] || null);
            } catch (error) {
                console.error("Failed to fetch teacher details", error);
            }
        };
        fetchInventoryDetails();
    }, [inventoryId]);

    if (!inventory) return <p>Loading inventory details...</p>;

    const formatCurrency = (amount) => {
        return parseFloat(amount).toLocaleString('id-ID', { minimumFractionDigits: 0 });
    };

    return (
        <div className={`page-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
            <div className="page-title">Stock Detail</div>
            <div className="form-container">
                <div className="section">
                    <h3 className="section-header">Stock Data</h3>
                    <table>
                        <tbody>
                            <tr>
                                <td>Item Name</td>
                                <td>:</td>
                                <td>{inventory.item_name}</td>
                            </tr>
                            <tr>
                                <td>Item Type</td>
                                <td>:</td>
                                <td>{inventory.item_type}</td>
                            </tr>
                            <tr>
                                <td>Price</td>
                                <td>:</td>
                                <td>{formatCurrency(inventory.price)}</td>
                            </tr>
                            <tr>
                                <td>Central Stock</td>
                                <td>:</td>
                                <td>{inventory.central_stock}</td>
                            </tr>
                            <tr>
                                <td>Branch Stock</td>
                                <td>:</td>
                                <td>{inventory.branch_stock}</td>
                            </tr>
                            {inventory.Program ? 
                            <tr>
                                <td>Program Name</td>
                                <td>:</td>
                                <td>{inventory.Program.program_name}</td>
                            </tr>
                            : ""}{inventory.Level ? 
                            <tr>
                                <td>Level Name</td>
                                <td>:</td>
                                <td>{inventory.Level.level_name}</td>
                            </tr>
                            : ""}
                            <tr>
                                <td>Last Update</td>
                                <td>:</td>
                                <td>{moment(inventory.changed_on).format('DD MMMM YYYY  HH:mm:ss')}</td>
                            </tr>
                            <tr>
                                <td>Last Update By</td>
                                <td>:</td>
                                <td>{inventory.changed_by}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="create-student-table">
                    <h3 className="section-header">Transaction Details</h3>
                    <table>
                        <thead>
                        <tr>
                        <th className='table-center-align'>No</th>
                            <th className='table-center-align'>Transaction Date</th>
                            <th className='table-center-align'>In</th>
                            <th className='table-center-align'>Out</th>
                            <th className='table-center-align'>Branch</th>
                            <th className='table-center-align'>Quantity</th>
                            <th className='table-center-align'>Sent By</th>
                            <th className='table-center-align'>Received By</th>
                        </tr>
                        </thead>
                        <tbody>
                        {inventory.InventoryHistories.map((inventoryHistory, index) => (
                            <tr key={inventoryHistory.inventory_history_id}>
                                <td class="no-column">{index + 1}</td>
                                <td>{moment(inventoryHistory.send_on).format('DD MMMM YYYY  HH:mm:ss')}</td>
                                <td class="no-column">{inventoryHistory.transaction_type === 'TRANSFER' ? 'X' : 'V'}</td>
                                <td class="no-column">{inventoryHistory.transaction_type === 'TRANSFER' ? 'V' : 'X'}</td>
                                <td className='table-right-align'>{inventoryHistory.Branch ? inventoryHistory.Branch.branch_name : "CENTRAL"}</td>
                                <td className='table-right-align'>{inventoryHistory.item_quantity}</td>
                                <td className='table-right-align'>{inventoryHistory.send_by}</td>
                                <td className='table-right-align'>{inventoryHistory.received_by}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
                <div className="search-container">
                    
                    <button className="profile-button" onClick={() => navigate('/inventory/list')}>Back</button>
                </div>
            </div>
        </div>
    );
};

export default StockDetailPage;
